"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _meetings = _interopRequireDefault(require("./modules/meetings"));

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var SalesModule = {
  route: _UrlPathParams.SALES,
  modules: [_meetings.default]
};
var _default = SalesModule;
exports.default = _default;
module.exports = exports.default;